/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ContractType = typeof ContractType[keyof typeof ContractType];


export const ContractType = {
  representation: 'representation',
  employment: 'employment',
  loan: 'loan',
  transfer: 'transfer',
  third_party: 'third_party',
  commercial: 'commercial',
  mandate: 'mandate',
  agent_subcontract: 'agent_subcontract',
  commission: 'commission',
} as const;
